import styled, { keyframes } from 'styled-components';
import { fadeIn, fadeInLeft, fadeInRight, fadeInDown, fadeInUp } from 'react-animations';
import { STATUS } from './LoginConsts';

const fadeInAnimation = keyframes`${fadeIn}`;
const fadeInLeftAnimation = keyframes`${fadeInLeft}`;
const fadeInRightAnimation = keyframes`${fadeInRight}`;
const fadeInDownAnimation = keyframes`${fadeInDown}`;
const fadeInUpAnimation = keyframes`${fadeInUp}`;

const Div = styled.div`
  display: flex;
  justify-content: center;
  height: 100vh;
  align-items: center;
  margin: 2% 0%;

  @media (max-width: 769px) {
    flex-direction: column;
    margin: 5% 0% 15% 0%;
  }
`;

const LeftBox = styled.div`
  width: 22%;
  height: 80%;
  box-shadow: 0 4px 15px 0 rgba(0, 0, 0, 0.8);

  @media (max-width: 769px) {
    height: 20%;
    width: 78%;
  }

  .wrapper {
    height: 100%;
    max-height: 100%;
    width: 100%;
    position: relative;
  }

  .color-mask {
    height: 100%;
    width: 100%;
    /* 紅藍 */
    background: linear-gradient(135deg, rgb(195, 12, 12, 0.8), rgb(10, 74, 154, 0.8));
    /* 藍綠 */
    /* background: linear-gradient(135deg,rgba(24, 254, 237, 0.80),rgba(97, 120, 234, 0.8)); */
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
  }

  img {
    max-height: 100%;
    height: 100%;
    width: 100%;
  }
`;

const RightBox = styled.div`
  background: white;
  width: 40%;
  min-height: 80%;
  box-shadow: 0 4px 15px 0 rgba(0, 0, 0, 0.8);
  display: flex;
  padding: 2% 5%;
  justify-content: center;
  align-items: center;
  animation: 2s ${fadeInAnimation};

  @media (max-width: 769px) {
    height: auto;
    width: 78%;
  }
`;

const ContentBox = styled.div`
  letter-spacing: 1px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 30%;

  .title {
    color: white;
    font-weight: 900;
    letter-spacing: 2px;
    font-size: 2rem;
    animation: 2s ${fadeInDownAnimation};
  }

  img {
    width: 35%;
    margin-top: 15%;
    animation: 1.5s ${fadeInLeftAnimation};
  }

  .msg-box {
    width: 92%;
    display: flex;
    color: white;
    justify-content: center;
    font-size: 0.8rem;
    position: absolute;
    bottom: 0.5rem;
    animation: 1.5s ${fadeInUpAnimation};

    .msg-link {
      font-weight: 800;
      margin-left: 10px;
      &:focus {
        outline: none;
      }
      &:hover {
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }

  @media (max-width: 769px) {
    margin: 5% 8%;
    align-items: flex-end;

    img {
      width: 22%;
      margin-top: 5%;
    }
  }

  @media (max-width: 1366px) {
    .title {
      font-size: 1.2rem;
    }
    .msg-box {
      flex-direction: column;
      align-items: flex-end;
    }
  }
`;

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  letter-spacing: 1px;
  animation: 0.6s ${({ status }) => (status === STATUS.SIGN_IN ? fadeInLeftAnimation : fadeInRightAnimation)};

  .upper-box {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 0.8rem;
    padding: 0 5%;
    color: rgb(10, 74, 154, 1);

    .connection-btns-box {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      margin-top: 0.6rem;
      button {
        margin: 1rem 0.6rem 0 0.6rem;
      }
    }
  }

  .bottom-box {
    width: 100%;
    margin-top: 6%;
    padding-top: 8%;
    border-top: 1px solid rgb(10, 74, 154, 0.3);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .input-field {
      width: 80%;
      display: flex;
      align-items: center;
      margin-bottom: 8%;
      img {
        width: 1.5rem;
        margin-right: 12px;
      }
      .input-box {
        display: flex;
        width: 100%;
        justify-content: space-between;
        input:not(:first-child) {
          margin-left: 0.5rem;
        }
      }
    }

    .forgot-pw-link {
      color: rgb(10, 74, 154, 1);
      font-size: 0.6rem;
      font-weight: 800;
      margin-top: 8%;
      &:hover {
        cursor: pointer;
        text-decoration: underline;
      }
    }

    .success-msg {
      font-size: 0.8rem;
      color: #70bd2f;
      margin: 4% 0 6%;
    }

    .error-msg {
      font-size: 0.8rem;
      color: #e8196e;
      margin: 4% 0 6%;
    }

    .normal-msg {
      font-size: 0.8rem;
      color: #1e1e1e;
      margin: 4% 0 6%;
    }

    .checkbox-label {
      padding: 0 0 0 0.5rem;
      font-size: 0.8rem;
    }
  }

  @media (max-width: 769px) {
    .upper-box .connection-btns-box {
      flex-direction: column;
      button {
        margin: 0 0 1rem 0;
      }
    }

    .bottom-box {
      margin-top: 10%;
      padding-top: 12%;
      width: 90%;

      .input-field {
        width: 100%;
        &.--multi-input {
          align-items: flex-start;
        }
        img {
          width: 1.1rem;
          margin-right: 8px;
        }
        .input-box {
          flex-direction: column;
          input:not(:first-child) {
            margin-left: 0;
            margin-top: 5%;
          }
        }
      }
    }
  }
`;

export { Div, LeftBox, RightBox, ContentBox, StyledForm };
